module.exports = __webpack_public_path__ + "img/bear1.9e0081b2.png";